module.exports = __webpack_public_path__ + "img/empty.ba8b5384.svg";